import { useIsAdmin } from 'providers/UserProvider';
import { useIsCustomer } from 'providers/CustomerProvider';
import { Redirect, Route } from 'react-router-dom';
import { getUserInStorage } from './Storage';

export default function PersonnelRoute({ component: Component, ...rest }) {
  const isAdmin = useIsAdmin();
  const isCustomer = useIsCustomer();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAdmin || getUserInStorage()?.isAdmin ? (
          <Component {...props} />
        ) : isCustomer ? (
          <Redirect to="/customer/events" />
        ) : (
          <Redirect to="/invoices" />
        )
      }
    />
  );
}
